import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Settings} from "../core/services/settings.service";

@Injectable()
export class DisableRouteGuard implements CanActivate {

    constructor(private settings: Settings, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if ( ! this.settings.get('registration.disable')) { return true; }

        this.router.navigate(['/login']);

        return false;
    }
}


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/guards/disable-route-guard.service.ts